import React from 'react'
import { Button } from '@/components/ui/button'
import { Heading3 } from '@/components/ui/typography'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { FormBaseRow, FormRowReversed } from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

import {
  FormErrorMessage,
  FormFieldBlock,
  FormFieldGroup,
  FormFieldLabel,
  MultiAdjustmentTemplate,
} from '../Transactions.styles'

export interface TransactionReverseFormValues {
  amount: number
  comment: string | null
}

const TransactionReverseFormUI: React.FC<FormikProps<TransactionReverseFormValues> & OuterProps> = (
  props
) => {
  const { handleSubmit, isSubmitting, errors, transaction } = props

  return (
    <MultiAdjustmentTemplate>
      <Form onSubmit={handleSubmit}>
        <Heading3>
          Reverse Transaction <span className='blue'>({transaction.referenceId})</span>
        </Heading3>
        <FormFieldBlock>
          <FormBaseRow>
            <FormFieldLabel>Amount</FormFieldLabel>
            <FormFieldGroup>
              <Field type='number' min='0' step='any' name='amount' disabled />
            </FormFieldGroup>
          </FormBaseRow>
          {errors.amount && <FormErrorMessage>{errors.amount}</FormErrorMessage>}
        </FormFieldBlock>
        <FormFieldBlock>
          <FormBaseRow>
            <FormFieldLabel>Comment</FormFieldLabel>
            <FormFieldGroup>
              <Field
                component='textarea'
                name='comment'
                placeholder='Enter comment'
                rows='3'
                maxLength='130'
              />
            </FormFieldGroup>
          </FormBaseRow>
        </FormFieldBlock>
        <FormFieldBlock>
          <FormBaseRow>
            <FormRowReversed>
              <Button disabled={isSubmitting} type='submit'>
                Submit
              </Button>
            </FormRowReversed>
          </FormBaseRow>
        </FormFieldBlock>
      </Form>
    </MultiAdjustmentTemplate>
  )
}

interface OuterProps {
  transaction: TransactionDto
  values?: TransactionReverseFormValues
  onSubmit(values: FormSubmitValues<TransactionReverseFormValues>): Promise<void>
}

export const TransactionReverseForm = withFormik<OuterProps, TransactionReverseFormValues>({
  mapPropsToValues: ({ values, transaction }) => {
    return (
      values || {
        amount: transaction.amount,
        comment: transaction.comment,
      }
    )
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    setSubmitting(true)
    await props.onSubmit(values)
    setSubmitting(false)
  },
  validate: (values) => {
    const errors: FormikErrors<TransactionReverseFormValues> = {}
    if (!values.amount) {
      errors.amount = 'required'
    }
    return errors
  },
  isInitialValid: false,
  enableReinitialize: true,
})(TransactionReverseFormUI)
